import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AccountInfo} from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class OdooService {

  private readonly _sessionId = new BehaviorSubject<string>('');

  public readonly sessionId$: Observable<string> = this._sessionId.asObservable();

  public setSessionId(sessionId: string): void {
    this._sessionId.next(sessionId);
  }

  public getSessionId(): string {
    return this._sessionId.value;
  }

  public clearSessionId(): void {
    this._sessionId.next('');
  }

}
